import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { chatMessageText } from '../styles';

export const markdownComponents = {
  p: ({ children }: { children?: React.ReactNode }) => (
    <Typography sx={{ ...chatMessageText, mb: 0.5 }}>{children}</Typography>
  ),
  strong: ({ children }: { children?: React.ReactNode }) => (
    <Box component="strong" sx={{ fontWeight: 700 }}>
      {children}
    </Box>
  ),
  em: ({ children }: { children?: React.ReactNode }) => (
    <Box component="em" sx={{ fontStyle: 'italic' }}>
      {children}
    </Box>
  ),
  // Links are intentionally rendered as plain text — the chat never shows clickable links; it
  // refers to reports by name and offers follow-up suggestions instead.
  a: ({ children }: { href?: string; children?: React.ReactNode }) => (
    <Box component="span" sx={chatMessageText}>
      {children}
    </Box>
  ),
  blockquote: ({ children }: { children?: React.ReactNode }) => (
    <Box
      sx={{
        borderLeft: '3px solid #6282FF',
        pl: 1.5,
        py: 0.25,
        my: 0.75,
        bgcolor: '#EEF2FF',
        borderRadius: '0 4px 4px 0',
      }}
    >
      {children}
    </Box>
  ),
  h4: ({ children }: { children?: React.ReactNode }) => (
    <Typography
      sx={{
        fontSize: 12,
        fontWeight: 600,
        color: '#5F6978',
        fontFamily: 'Inter, sans-serif',
        lineHeight: '16px',
        mt: 1.5,
        mb: 0.5,
        pt: 0.5,
        borderTop: '1px solid #e2e8f0',
      }}
    >
      {children}
    </Typography>
  ),
  ul: ({ children }: { children?: React.ReactNode }) => (
    <Box component="ul" sx={{ pl: 2.5, my: 0.5, '& li': { mb: 0.25 } }}>
      {children}
    </Box>
  ),
  ol: ({ children }: { children?: React.ReactNode }) => (
    <Box component="ol" sx={{ pl: 2.5, my: 0.5, '& li': { mb: 0.25 } }}>
      {children}
    </Box>
  ),
  li: ({ children }: { children?: React.ReactNode }) => (
    <Box component="li">
      <Typography sx={chatMessageText}>{children}</Typography>
    </Box>
  ),
  table: ({ children }: { children?: React.ReactNode }) => (
    <Box sx={{ overflowX: 'auto', my: 1 }}>
      <Table
        size="small"
        sx={{
          '& .MuiTableCell-root': {
            fontSize: 13,
            fontFamily: 'Inter, sans-serif',
            py: 0.75,
            px: 1.25,
            borderColor: '#e2e8f0',
          },
        }}
      >
        {children}
      </Table>
    </Box>
  ),
  thead: ({ children }: { children?: React.ReactNode }) => <TableHead>{children}</TableHead>,
  tbody: ({ children }: { children?: React.ReactNode }) => <TableBody>{children}</TableBody>,
  tr: ({ children }: { children?: React.ReactNode }) => <TableRow>{children}</TableRow>,
  th: ({ children }: { children?: React.ReactNode }) => (
    <TableCell sx={{ fontWeight: 600, bgcolor: '#EEF2FF', color: '#020f20', whiteSpace: 'nowrap' }}>
      {children}
    </TableCell>
  ),
  td: ({ children }: { children?: React.ReactNode }) => (
    <TableCell sx={{ color: '#334155' }}>{children}</TableCell>
  ),
};
